import { t, type ErrorCodeMapperEntry } from "./types.js";

/** Error codes 34000-34999. One thousand-block per file: a duplicate number here can only
 *  collide within this file, which is what makes the split safer than one shared object. */
export const foldersErrors = {
  // 34xxx is the folders module's series. One site reused FOLDER_NOT_FOUND (25008) verbatim.
  // 34001-34009 — the folders module's split.
  FOLDER_USER_NOT_SPACE_MEMBER: {
    errorCode: 34001,
    errorMessage: t("User is not a member of this Space"),
    isDynamic: false,
  },
  FOLDER_ROLE_NO_ACCESS_RECORD: {
    errorCode: 34002,
    errorMessage: t("Could not apply the role: the user has no access record on this resource"),
    isDynamic: false,
  },
  // 34003/34008: the same "not in a Space" precondition, named for the two different things it
  // blocks. Separate sentences today, so separate codes.
  RESOURCE_NOT_IN_SPACE_NO_REVISION_SERIES: {
    errorCode: 34003,
    errorMessage: t("This resource is not in a Space, so it has no revision series."),
    isDynamic: false,
  },
  REVISION_SERIES_NOT_FOUND_IN_PORTAL: {
    errorCode: 34004,
    errorMessage: t("Revision series not found in this portal"),
    isDynamic: false,
  },
  REVISION_SERIES_NOT_APPLICABLE: {
    errorCode: 34005,
    errorMessage: t("Revision series cannot be applied to this resource"),
    isDynamic: false,
  },
  // A FOURTH wording of permission-denied, after INSUFFICIENT_PERMISSION (7012, "You do not have
  // Required permission"), SUPPORT_INSUFFICIENT_ACCESS (13009, "Insufficient access") and
  // PERMISSION_CHANGE_USER_ACCESS_DENIED (7084). Kept separate to preserve the text; the cluster is
  // a harmonisation candidate if a copy change is ever approved.
  INSUFFICIENT_PERMISSION_PLAIN: {
    errorCode: 34006,
    errorMessage: t("Insufficient permission"),
    isDynamic: false,
  },
  RESOURCE_NOT_FOUND_PLAIN: {
    errorCode: 34007,
    errorMessage: t("Resource not found."),
    isDynamic: false,
  },
  RESOURCE_NOT_IN_SPACE_NO_NOMENCLATURE_TEMPLATE: {
    errorCode: 34008,
    errorMessage: t("This resource is not in a Space, so it has no nomenclature template."),
    isDynamic: false,
  },
  // Deliberately not PORTAL_NOMENCLATURE_TEMPLATE_NOT_FOUND (22004-range), whose sentence omits
  // "in this portal".
  NOMENCLATURE_TEMPLATE_NOT_FOUND_IN_PORTAL: {
    errorCode: 34009,
    errorMessage: t("Nomenclature template not found in this portal"),
    isDynamic: false,
  },
  FOLDER_ROLE_NO_PERMISSION_RECORD_TRANSMITTAL: {
    errorCode: 34010,
    errorMessage: t("Could not apply the role: no permission record exists for this transmittal"),
    isDynamic: false,
  },
  FOLDER_ROLE_INVALID: {
    errorCode: 34011,
    errorMessage: t("Invalid role"),
    isDynamic: false,
  },
  RESOURCE_TASK_REMOVAL_FAILED: {
    errorCode: 34012,
    errorMessage: t("The resources could not be removed from the task."),
    isDynamic: false,
  },
} satisfies Record<string, ErrorCodeMapperEntry>;
